import {IMask} from "../bootstrap";

window.addEventListener('load', function () {
    let cardNumber = document.querySelectorAll('.card-number');
    if (cardNumber.length) {
        let cardNumberOptions = {
            mask: '0000 0000 0000 0000'
        }
        for (let i = 0; i < cardNumber.length; ++i) {
            IMask(cardNumber[i], cardNumberOptions)
        }
    }

    let cardExpDate = document.querySelectorAll('.card-exp-date');
    if (cardExpDate.length) {
        let cardExpDateOptions = {
            mask: 'MM/YY',
            blocks: {
                YY: {
                    mask: '00'
                },
                MM: {
                    mask: IMask.MaskedRange,
                    from: 1,
                    to: 12
                }
            }
        }
        for (let i = 0; i < cardExpDate.length; ++i) {
            IMask(cardExpDate[i], cardExpDateOptions)
        }
    }

    let cardCVC = document.querySelectorAll('.card-cvc');
    if (cardCVC.length) {
        let cardCVCOptions = {
            mask: '000'
        }
        for (let i = 0; i < cardCVC.length; ++i) {
            IMask(cardCVC[i], cardCVCOptions)
        }
    }

    let amount = document.querySelectorAll('.card-amount');
    if (amount.length) {
        let amountOptions = {
            mask: Number
        }
        for (let i = 0; i < amount.length; ++i) {
            IMask(amount[i], amountOptions);
        }
    }

    let phone = document.querySelectorAll('.phone-input');
    if (phone.length) {
        let phoneOptions = {
            mask: Number,
        }
        for (let i = 0; i < phone.length; ++i) {
            IMask(phone[i], phoneOptions)
        }
    }
})
